import type { TFunction } from 'i18next';
import { INVALID_URL_FORMAT_ERROR_KEY } from './DomainUrlValidation';

export function translateDomainValidationErrorKey(
  t: TFunction,
  errorKey: string
): string {
  return t(errorKey, { defaultValue: t(INVALID_URL_FORMAT_ERROR_KEY) });
}
